import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fe357a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-input-group__label-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_label = _resolveComponent("oxd-label")!
  const _component_oxd_text = _resolveComponent("oxd-text")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.rootClasses)
  }, [
    _renderSlot(_ctx.$slots, "label", {}, () => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.labelIcon)
          ? (_openBlock(), _createBlock(_component_oxd_icon, {
              key: 0,
              name: _ctx.labelIcon,
              class: "oxd-input-group__label-icon"
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        (_ctx.label)
          ? (_openBlock(), _createBlock(_component_oxd_label, {
              key: 1,
              label: _ctx.label,
              class: _normalizeClass(_ctx.labelClasses)
            }, null, 8, ["label", "class"]))
          : _createCommentVNode("", true)
      ])
    ], true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.wrapperClasses)
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2),
    _renderSlot(_ctx.$slots, "message", {}, () => [
      (_ctx.message)
        ? (_openBlock(), _createBlock(_component_oxd_text, {
            key: 0,
            class: _normalizeClass(_ctx.messageClasses),
            tag: "span"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.message), 1)
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ], true)
  ], 2))
}